import React, { Component } from 'react'
import PreferredPeriodComponent from './PreferredPeriodComponent'
import { MuiGrid } from '../../../../../ui/MaterialUIComponents'
import lodashUtil from 'lodash';
import { DialogComponentUtil } from '..';
import { gradePickerUtil } from '../../../../gradePicker/'
import { toast } from 'react-toastify';
import RulesMenuComponent from '../../RulesMenuComponent';
import { ConstraintsAndPreferences, CalculateUtil } from '..';
import { PreferredPeriodsUtil } from '.';
export class PreferredPeriodContainer extends Component {

	constructor(props) {
		super(props);
		let cellData = this.props.dataTableMap.get(this.props.cellCode)
		let preferredPeriod = undefined;
		let electiveId = undefined;
		let subjectId = undefined;

		if (cellData.elective !== undefined) {
			preferredPeriod = {
				electiveId: cellData.elective._id,
				electiveName: cellData.elective.name,
				preferences: [],
			}
		} else {
			preferredPeriod = {
				subjectId: cellData.subject._id,
				subjectName: cellData.subject.name,
				subjectCode: cellData.subject.code,
				preferences: [],
			}
		}
		let roomList = []
		this.state = {
			keyArray: [],
			periodObj: JSON.parse(JSON.stringify(this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].preferredPeriods)),
			roomList: roomList,
			preferredPeriod: preferredPeriod,
			isScheduleOpen: false,
			weeklyAvailabilitySchedule: [
				{ id: 1, weekDays: [], outFrom: "", outUntill: "" }
			],
			tempActiveSchool: JSON.parse(JSON.stringify(this.props.activeSchool)),
			periodsDetails: undefined,
			isScheduleOpen: true,
		}
	}
	constructWeeklyAvailability = weeklyAvailabilitySchedule => {

		let weekDaysJSON = {
			"1": "SUN",
			"2": "MON",
			"3": "TUE",
			"4": "WED",
			"5": "THU",
			"6": "FRI",
			"7": "SAT"
		}
		let weeklyAvailabilityList = [];
		let weeklyAvailabilityDisplayList = []
		if (weeklyAvailabilitySchedule.length > 0) {
			for (let i = 0; i < weeklyAvailabilitySchedule.length; i++) {
				if (weeklyAvailabilitySchedule[i].weekDays.length > 0) {
					for (let j = 0; j < weeklyAvailabilitySchedule[i].weekDays.length; j++) {
						let weeklyAvailability = {};
						weeklyAvailability.weekDay = weeklyAvailabilitySchedule[i].weekDays[j]
						weeklyAvailability.after = weeklyAvailabilitySchedule[i].outFrom;
						weeklyAvailability.before = weeklyAvailabilitySchedule[i].outUntill;
						weeklyAvailability.groupNumber = i;
						weeklyAvailabilityList.push(weeklyAvailability);
					}
				}

				let weeklyAvailabilityDisplayString = "";
				if (weeklyAvailabilitySchedule[i].weekDays.length == 1) {
					weeklyAvailabilityDisplayString = weekDaysJSON[weeklyAvailabilitySchedule[i].weekDays[0]] + " : " + weeklyAvailabilitySchedule[i].outFrom + " - " + weeklyAvailabilitySchedule[i].outUntill;
				} else {
					weeklyAvailabilityDisplayString = weekDaysJSON[weeklyAvailabilitySchedule[i].weekDays[0]] + " - " + weekDaysJSON[weeklyAvailabilitySchedule[i].weekDays[weeklyAvailabilitySchedule[i].weekDays.length - 1]] + " : " + weeklyAvailabilitySchedule[i].before + " - " + weeklyAvailabilitySchedule[i].after;
				}
				weeklyAvailabilityDisplayList.push(weeklyAvailabilityDisplayString)
			}
			this.setState({
				weeklyAvailabilityDisplayList: weeklyAvailabilityDisplayList
			});
		}

		return {
			weeklyAvailabilityList: weeklyAvailabilityList,
			weeklyAvailabilityDisplayList: weeklyAvailabilityDisplayList
		};
	};
	renderAvailabilityScheduleRow = () => {
		let weeklyAvailabilitySchedule = this.state.weeklyAvailabilitySchedule;
		weeklyAvailabilitySchedule.push({
			id: weeklyAvailabilitySchedule.length + 1,
			weekDays: [],
			outFrom: "",
			outUntill: ""
		});
		this.setState({
			weeklyAvailabilitySchedule: weeklyAvailabilitySchedule
		});
	};

	removeWeeklyAvailabilitySchedule = key => {
		let weeklyAvailabilitySchedule = this.state.weeklyAvailabilitySchedule;
		weeklyAvailabilitySchedule.splice(key, 1);
		this.setState({ weeklyAvailabilitySchedule: weeklyAvailabilitySchedule });
	};

	getPreferredPeriodString = (preferredPeriod) => {
		const weekDaysJSON = {
			"1": "Sun",
			"2": "Mon",
			"3": "Tue",
			"4": "Wed",
			"5": "Thu",
			"6": "Fri",
			"7": "Sat"
		}
		let preferencesArray = [];
		for (let a = 0; a < preferredPeriod.preferences.length; a++) {
			let preferencesObj = preferredPeriod.preferences[a]
			let groupNumber = preferencesObj.groupNumber;
			let weekDayArray = lodashUtil.filter(preferredPeriod.preferences, ["groupNumber", groupNumber]);
			if (weekDayArray.length != 0) {
				weekDayArray = lodashUtil.orderBy(weekDayArray, ["weekDay"], ["asc"])
				a += weekDayArray.length - 1
				let preferredDaysArray = []
				for (let b = 0; b < weekDayArray.length; b++) {
					let weekDay = weekDayArray[b].weekDay
					preferredDaysArray.push(weekDaysJSON[weekDay])
				}
				let prefereedDaysString = preferredDaysArray.toString()
				// DAYS- -BEFORE
				if (preferencesObj.after === "" || typeof preferencesObj.after === 'number') {
					preferencesArray.push(`${prefereedDaysString}- -${preferencesObj.before}`)
				}
				// DAYS-AFTER-
				else if (preferencesObj.before === "" || typeof preferencesObj.before === 'number') {
					preferencesArray.push(`${prefereedDaysString}-${preferencesObj.after}-`)
				}
				// DAYS-AFTER-BEFORE
				else {
					preferencesArray.push(`${prefereedDaysString}-${preferencesObj.after}-${preferencesObj.before}`)
				}
			}
		}
		let showpreferredPeriodString = preferencesArray.toString();
		return showpreferredPeriodString
	}

	onClickOfSave = async () => {
		const i18n = this.props.i18n
		let preferredPeriod = JSON.parse(JSON.stringify(this.state.preferredPeriod));
		let flag = true;
		let weeklyAvailabilitySchedule = this.state.weeklyAvailabilitySchedule;
		if (weeklyAvailabilitySchedule.length > 0) {
			for (let i = 0; i < weeklyAvailabilitySchedule.length; i++) {
				if (weeklyAvailabilitySchedule[i].weekDays.length === 0) {
					toast(i18n.teachers.selectAtleastOneWeekDay)
					flag = false;
					break;
				}
			}
		}

		if (flag === true) {
			preferredPeriod.preferences = this.constructWeeklyAvailability(weeklyAvailabilitySchedule).weeklyAvailabilityList

			let tempActiveSchool = this.state.tempActiveSchool;
			//tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].modifiedDate = new Date();
			let keys = this.props.keys;
			let cellDetails = undefined;
			let gradeLevels = this.props.activeSchool.school_master.gradeLevels
			let objMatching = false;
			let templetObjForCreatingNewObj = undefined;
			let preferredPeriods = tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].preferredPeriods

			preferredPeriod.showPreferredPeriodString = this.getPreferredPeriodString(preferredPeriod);

			let validationFlag = true;
			validationFlag = this.validationForSaving(preferredPeriod);

			if (validationFlag === true) {
				if (lodashUtil.isEmpty(this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex])) {
					tempActiveSchool.schedule_constraints = [
						{ preferredPeriods: [] }
					]
				}

				//KEYS 
				for (let c = 0; c < keys.length; c++) {
					cellDetails = this.props.dataTableMap.get(keys[c]);
					// gradeDetails from subject or elective 
					let cellGradeDetails = undefined;
					if (cellDetails.subject !== undefined) {
						cellGradeDetails = cellDetails.subject.gradeDetails
					} else if (cellDetails.elective !== undefined) {
						cellGradeDetails = cellDetails.elective.gradeDetails
					}
					// "EDIT" if preferredPeriod is already present 
					if (cellDetails.preferredPeriod !== undefined) {
						//EDITING FOR GROUPS
						if (this.props.filter.showSections === true) {
							let count = 0;
							let index = undefined;
							let cellDetails_preferredPeriod = cellDetails.preferredPeriod

							let preferences = preferredPeriod.preferences
							let objIndex = DialogComponentUtil.findConstraintObjIndexToReplace(preferredPeriods, cellDetails_preferredPeriod)

							if (objIndex === undefined) {
								objMatching = false
							} else {
								let obj = preferredPeriods[objIndex]

								if (preferences.length === obj.preferences.length) {
									for (let k = 0; k < preferences.length; k++) {
										if (obj.weekDay === preferences[k].weekDay
											&& obj.after === preferences[k].after
											&& obj.before === preferences[k].before
											&& obj.groupNumber === preferences[k].groupNumber) {
											objMatching = true;
											break;
										}
									}
								}
							}

							if (objMatching === false) {
								// remove obj code 
								for (let d = 0; d < preferredPeriods.length; d++) {
									let gradeObj = preferredPeriods[d].gradeDetails.grades[0]
									if ((cellDetails.subject && cellDetails.subject._id == preferredPeriods[d].subjectId) || (cellDetails.elective && cellDetails.elective._id == preferredPeriods[d].electiveId)) {
										if (gradeObj.grade === cellDetails.grade) {
											count++
											if (gradeObj.groups.length === 0) {
												index = d;
											}

										}
									}
								}
								// SPLICE
								let subGradeObj;
								let isLevelPresent = lodashUtil.find(cellGradeDetails.gradeLevels, ['level', cellDetails.gradeLevel])
								if (isLevelPresent !== undefined) {
									let gradeLevelObj = lodashUtil.find(gradeLevels, ['levelName', cellDetails.gradeLevel])
									if (gradeLevelObj !== undefined)
										subGradeObj = lodashUtil.find(gradeLevelObj.grades, ["gradeName", cellDetails.grade]);
								} else {
									subGradeObj = lodashUtil.find(cellGradeDetails.grades, ["grade", cellDetails.grade]);
								}
								// check if the SUBJECT is present for all the grade if not for all the GROUPS fro the selected GRADE.
								if (cellGradeDetails.allGrades === true || subGradeObj.groups.length === 0) {
									for (let p = 0; p < gradeLevels.length; p++) {
										let gradeLevel = gradeLevels[p]
										let selectedObj = lodashUtil.find(gradeLevel.grades, ["gradeName", cellDetails.grade])
										if (selectedObj !== undefined) {
											if ((count === (selectedObj.groups.length + 1)) && index !== undefined) {
												preferredPeriods.splice(index, 1);
												break;
											}
										}
									}
								}
								// SUBJECT is there only for SOME GROUPS in that grade.
								else {
									if ((count === (subGradeObj.groups.length + 1)) && index !== undefined) {
										preferredPeriods.splice(index, 1);
									}
								}
							}

							let objectIndex = DialogComponentUtil.findConstraintObjIndexToReplace(preferredPeriods, cellDetails_preferredPeriod)
							if (objectIndex !== undefined) {
								preferredPeriods[objectIndex].preferences = JSON.parse(JSON.stringify(preferredPeriod.preferences))
								preferredPeriods[objectIndex].showPreferredPeriodString = JSON.parse(JSON.stringify(preferredPeriod.showPreferredPeriodString))
							}
						}
						//"GRADES" show sections is false so we are clicking on grades which already has the data 
						else {
							let cellDetails_preferredPeriod = cellDetails.preferredPeriod
							let preferences = preferredPeriod.preferences
							let objMatching = false;

							let objIndex = DialogComponentUtil.findConstraintObjIndexToReplace(preferredPeriods, cellDetails_preferredPeriod)
							if (objIndex === undefined) {
								objMatching = false
							} else {
								let obj = preferredPeriods[objIndex]
								if (preferences.length === obj.preferences.length) {
									for (let k = 0; k < preferences.length; k++) {
										if (obj.weekDay === preferences[k].weekDay
											&& obj.after === preferences[k].after
											&& obj.before === preferences[k].before
											&& obj.groupNumber === preferences[k].groupNumber) {
											objMatching = true;
											break;
										}
									}
								}
							}
							if (objMatching === false) {

								//all the groups should eb over ridden with this value
								for (let h = 0; h < preferredPeriods.length; h++) {

									if ((cellDetails.subject && cellDetails.subject._id == preferredPeriods[h].subjectId) || (cellDetails.elective && cellDetails.elective._id == preferredPeriods[h].electiveId)) {
										if (preferredPeriods[h].gradeDetails.grades[0].grade === cellDetails.grade) {
											preferredPeriods[h].preferences = JSON.parse(JSON.stringify(preferredPeriod.preferences));
											preferredPeriods[h].showPreferredPeriodString = preferredPeriod.showPreferredPeriodString;

											if (preferredPeriods[h].gradeDetails.grades[0].groups.length != 0) {
												if (templetObjForCreatingNewObj === undefined) {
													templetObjForCreatingNewObj = JSON.parse(JSON.stringify(preferredPeriods[h]))
												}
											}

										}

									}
								}
							}
							this.creatingPreferredPeriodObjForJointClass(templetObjForCreatingNewObj, cellDetails, tempActiveSchool)
						}
					}

					//"NEW OBJECT" if preferredPeriod is not present in the schedule constraint
					else {
						// if the selected cell is for the grade and not for groups
						if (cellDetails.group === undefined) {
							//grade's object from master
							for (let g = 0; g < gradeLevels.length; g++) {
								let gradeObj = lodashUtil.find(gradeLevels[g].grades, ['gradeName', cellDetails.grade]);
								//GRADE (groups is empty)
								if (gradeObj !== undefined) {
									let preferredPeriodObj = JSON.parse(JSON.stringify(preferredPeriod));
									let gradeDetails = {
										allGrades: false,
										gradeLevels: [{
											level: cellDetails.gradeLevel
										}],
										grades: [{
											grade: cellDetails.grade,
											groups: [],
										}],
									}
									preferredPeriodObj.gradeDetails = gradeDetails;
									tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].preferredPeriods.push(preferredPeriodObj);

									let existingGroupArray = [];
									for (let x = 0; x < preferredPeriods.length; x++) {
										if ((cellDetails.subject && cellDetails.subject._id == preferredPeriods[x].subjectId) || (cellDetails.elective && cellDetails.elective._id == preferredPeriods[x].electiveId)) {
											if (preferredPeriods[x].gradeDetails.grades[0].grade === cellDetails.grade && preferredPeriods[x].gradeDetails.grades[0].groups.length > 0) {
												existingGroupArray.push(preferredPeriods[x].gradeDetails.grades[0].groups[0].groupCode)

												preferredPeriods[x].preferences = JSON.parse(JSON.stringify(preferredPeriod.preferences));
												preferredPeriods[x].showPreferredPeriodString = preferredPeriod.showPreferredPeriodString;

												if (templetObjForCreatingNewObj === undefined) {
													templetObjForCreatingNewObj = JSON.parse(JSON.stringify(preferredPeriods[x]))
												}

											}
										}
									}
									// to create NEW data to all the groups  
									//  VALIDATIONS if the subject or elective has gradeDetails ALL GRADE = TRUE or there is NO GROUPS for the grade
									let commonGradeObj;
									let cellGrade = lodashUtil.find(cellGradeDetails.grades, ["grade", cellDetails.grade]);
									let gradeObj = undefined
									for (let t = 0; gradeLevels.length; t++) {
										let gradeLevel = gradeLevels[t];
										gradeObj = lodashUtil.find(gradeLevel.grades, ['gradeName', cellDetails.grade]);
										if (gradeObj !== undefined) {
											break;
										}
									}
									if (cellGradeDetails !== undefined) {
										commonGradeObj = gradeObj;
									}

									for (let m = 0; m < commonGradeObj.groups.length; m++) {
										// AFTER GRADE => GROUPS
										if (!existingGroupArray.includes(commonGradeObj.groups[m].groupName)) {
											let preferredPeriodObj = JSON.parse(JSON.stringify(preferredPeriod));
											let gradeDetails = {
												allGrades: false,
												gradeLevels: [{
													level: cellDetails.gradeLevel
												}],
												grades: [{
													grade: cellDetails.grade,
													groups: [{
														groupCode: commonGradeObj.groups[m].groupName !== undefined ? commonGradeObj.groups[m].groupName : commonGradeObj.groups[m].groupCode
													}],
												}],
											}
											preferredPeriodObj.gradeDetails = gradeDetails;
											tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].preferredPeriods.push(preferredPeriodObj)

											if (templetObjForCreatingNewObj === undefined) {
												templetObjForCreatingNewObj = JSON.parse(JSON.stringify(preferredPeriodObj))
											}

										}
									}
									break;
								}
							}
							this.creatingPreferredPeriodObjForJointClass(templetObjForCreatingNewObj, cellDetails, tempActiveSchool)
						}
						// selected cell for GROUPS
						else {
							let preferredPeriodObj = JSON.parse(JSON.stringify(preferredPeriod));
							let gradeDetails = {
								allGrades: false,
								gradeLevels: [{
									level: cellDetails.gradeLevel
								}],
								grades: [{
									grade: cellDetails.grade,
									groups: [
										{ groupCode: cellDetails.group }
									],
								}],
							}
							preferredPeriodObj.gradeDetails = gradeDetails;
							if (cellDetails.jointClass !== undefined) {
								preferredPeriodObj.jointClassId = cellDetails.jointClass._id
							}
							preferredPeriods.push(preferredPeriodObj)
						}
					}
				}
				tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex] = await CalculateUtil.calculateConstraintsAndPreference(tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex],
					ConstraintsAndPreferences.Constants.PREFERRED_PERIODS)

				await this.props.updateDialogSave(tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex]);
				this.attachingDataToCell();
				this.props.handleCloseForDialog();
				this.props.handleClose();

			}
		}
	};

	creatingPreferredPeriodObjForJointClass = (templetObjForCreatingNewObj, cellDetails, tempActiveSchool) => {
		let cellDetails_grade = cellDetails.grade
		let jointClassArray = tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].jointClasses
		let preferredPeriodsArray = tempActiveSchool.schedule_constraints[this.props.activeScheduleIndex].preferredPeriods

		//JOINT CLASS ARRAY
		for (let a = 0; a < jointClassArray.length; a++) {
			let jointClassObj = JSON.parse(JSON.stringify(jointClassArray[a]));
			if ((cellDetails.subject && cellDetails.subject._id == jointClassObj.subjectId) || (cellDetails.elective && cellDetails.elective._id == jointClassObj.electiveId)) {
				let gradeDetails_gradesArray = jointClassObj.gradeDetails.grades

				let gradeIndex = lodashUtil.findIndex(gradeDetails_gradesArray, ['grade', cellDetails_grade])
				if (gradeIndex != -1) {

					//JOINT CLASS GRADE 
					for (let b = 0; b < gradeDetails_gradesArray.length; b++) {
						let gradeObj = gradeDetails_gradesArray[b]

						// JOINT CLASS GROUPS 
						for (let c = 0; c < gradeObj.groups.length; c++) {
							let groupObj = gradeObj.groups[c];
							let isGroupObjPresent = false;

							//PREFERRED PERIODS FROM DATABASE
							for (let d = 0; d < preferredPeriodsArray.length; d++) {
								let preferredPeriodObj = preferredPeriodsArray[d];
								let preferredPeriodObj_grades = preferredPeriodObj.gradeDetails.grades[0]
								// REPLACING THE VALUES IN THE DATABASE ARRAY
								if (preferredPeriodObj_grades.grade === gradeObj.grade
									&& preferredPeriodObj_grades.groups != undefined
									&& preferredPeriodObj_grades.groups.length > 0
									&& preferredPeriodObj_grades.groups[0].groupCode === groupObj.groupCode) {

									preferredPeriodObj.preferences = JSON.parse(JSON.stringify(templetObjForCreatingNewObj.preferences))
									preferredPeriodObj.showPreferredPeriodString = templetObjForCreatingNewObj.showPreferredPeriodString
									preferredPeriodObj.jointClassId = jointClassObj._id
									isGroupObjPresent = true
									break;
								}
							}

							// CREATE NEW OBJECT FOR PARTICULAR GROUPS
							if (isGroupObjPresent === false) {
								let tempObj = JSON.parse(JSON.stringify(templetObjForCreatingNewObj));
								delete tempObj._id;
								tempObj.gradeDetails.grades[0].grade = gradeObj.grade;
								tempObj.gradeDetails.grades[0].groups[0].groupCode = groupObj.groupCode;
								tempObj.jointClassId = jointClassObj._id
								preferredPeriodsArray.push(tempObj);
							}
						}
					}
				}
			}
		}
	}

	validationForSaving = (preferredPeriod) => {
		const i18n = this.props.i18n
		if (preferredPeriod.preferences.length != 0) {
			let preferences = preferredPeriod.preferences
			for (let i = 0; i < preferences.length; i++) {
				let preferenceObject = preferences[i]
				if (preferenceObject.before === "" && preferenceObject.after === "") {
					toast(i18n.preferredPeriod.afterOrBefore);
					return false;
				}
			}
		}

		return true;
	}

	showExistingPeriod = () => {
		if (this.props.activeSchool.schedule_constraints !== undefined) {
			let weeklyAvailabilitySchedule = this.state.weeklyAvailabilitySchedule
			let preferredPeriod = this.state.preferredPeriod
			let preferredPeriods = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].preferredPeriods
			let preferredPeriodObj;
			if (preferredPeriods !== undefined && preferredPeriods.length > 0) {
				let celldetails = this.props.dataTableMap.get(this.props.cellCode)
				// groups is not present

				if (this.props.filter.showSections === false && celldetails.groups === undefined) {
					for (let b = 0; b < preferredPeriods.length; b++) {
						if (preferredPeriods[b].gradeDetails.grades[0].groups.length === 0) {
							if ((celldetails.subject && celldetails.subject._id == preferredPeriods[b].subjectId) || (celldetails.elective && celldetails.elective._id == preferredPeriods[b].electiveId)) {
								let grade = preferredPeriods[b].gradeDetails.grades
								let isObjectPresent = lodashUtil.find(grade, ['grade', celldetails.grade])
								if (isObjectPresent !== undefined) {
									if (isObjectPresent.groups.length === 0) {
										preferredPeriodObj = JSON.parse(JSON.stringify(preferredPeriods[b]))
										delete preferredPeriodObj.gradeDetails
										this.setState({
											preferredPeriod: preferredPeriodObj
										})
									}
								}
							}
						}
					}
				}
				// group is present
				if (this.props.filter.showSections === true && celldetails.group !== undefined) {
					for (let c = 0; c < preferredPeriods.length; c++) {
						if (preferredPeriods[c].gradeDetails.grades[0].groups.length !== 0) {
							if ((celldetails.subject && celldetails.subject._id == preferredPeriods[c].subjectId) || (celldetails.elective && celldetails.elective._id == preferredPeriods[c].electiveId)) {
								let grades = preferredPeriods[c].gradeDetails.grades
								let isObjPresent = lodashUtil.find(grades, ['grade', celldetails.grade])
								if (isObjPresent !== undefined) {
									let groupCode = isObjPresent.groups[0].groupCode

									if (groupCode === celldetails.group) {
										preferredPeriodObj = JSON.parse(JSON.stringify(preferredPeriods[c]))
										delete preferredPeriodObj.gradeDetails
										this.setState({
											preferredPeriod: preferredPeriodObj
										})
									}
								}
							}
						}
					}
				} this.destructorOfWeeklyAvailabilitySchedule(preferredPeriodObj)
			}
		}
	}

	destructorOfWeeklyAvailabilitySchedule = (weeklyAvailability) => {
		if (
			weeklyAvailability != undefined &&
			!lodashUtil.isEmpty(weeklyAvailability)
		) {
			let weeklyAvailabilitySchedule = [];
			const results = lodashUtil.groupBy(
				weeklyAvailability.preferences, "groupNumber"
			);
			const groupNumbers = lodashUtil.keys(results);

			for (let i = 0; i < groupNumbers.length; i++) {
				let schedule = {};
				schedule.weekDays = [];
				for (let j = 0; j < results[groupNumbers[i]].length; j++) {
					schedule.weekDays.push(
						results[groupNumbers[i]][j].weekDay.toString()
					);
					schedule.id = i;
					schedule.outFrom = results[groupNumbers[i]][j].after;
					schedule.outUntill = results[groupNumbers[i]][j].before;
				}
				weeklyAvailabilitySchedule.push(schedule);
			}

			if (weeklyAvailabilitySchedule.length > 0) {
				this.setState({
					weeklyAvailabilitySchedule: weeklyAvailabilitySchedule
				});
			} else {
				this.setState({
					weeklyAvailabilitySchedule: [
						{ id: 1, weekDays: [], outFrom: "", outUntill: "" }
					]
				});
			}
		}
	}
	attachingDataToCell = () => {
		let preferredPeriods = this.props.activeSchool.schedule_constraints[this.props.activeScheduleIndex].preferredPeriods;
		let dataTableMap = this.props.dataTableMap;
		for (let i = 0; i < preferredPeriods.length; i++) {
			let grades = preferredPeriods[i].gradeDetails.grades[0];

			if (this.props.filter.showSections === false) {
				if (grades.groups.length === 0) {
					for (let [key, value] of dataTableMap) {
						if ((value.subject && value.subject._id == preferredPeriods[i].subjectId) || (value.elective && value.elective._id == preferredPeriods[i].electiveId)) {
							if (value.grade === grades.grade) {
								value.preferredPeriod = preferredPeriods[i];
								dataTableMap.set(key, value);
								break;
							}
						}
					}
				}
			}
			// GROUPS attaching it to groups
			else {
				if (grades.groups.length !== 0) {
					for (let [key, value] of dataTableMap) {
						if ((value.subject && value.subject._id == preferredPeriods[i].subjectId) || (value.elective && value.elective._id == preferredPeriods[i].electiveId)) {
							if (value.grade === grades.grade) {
								if (value.group === grades.groups[0].groupCode) {
									value.preferredPeriod = preferredPeriods[i];
									dataTableMap.set(key, value);
									break;
								}
							}
						}
					}
				}
			}
		}
	}
	componentWillMount() {
		this.showExistingPeriod()
		this.getCalendarPeriods();
	}

	getCalendarPeriods = () => {
		const i18n = this.props.i18n
		let props = this.props
		let keysArray = [...props.keys];
		let weeklyCalendar = JSON.parse(JSON.stringify(props.activeSchool.schedule_constraints[props.activeScheduleIndex].weeklyCalendar));
		let isAllSelectedGradePresent = true;
		let periodsArrayToDisplay = []
		//if there is only 1 calendar
		if (weeklyCalendar !== undefined) {
			//for (let i = 0; i < weeklyCalendar.length; i++) {
				isAllSelectedGradePresent = true;
				let calendar = weeklyCalendar[0]
				let gradeDetails = calendar.gradeDetails
				if (gradeDetails.allGrades === true) {
					periodsArrayToDisplay = PreferredPeriodsUtil.getPeriodNameArray(calendar.periodsDetails);
				} else {
					//getting CALENDAR GRADE DETAILS to the lowest form.
					let calendar_gradeStringArray = gradePickerUtil.convertingGradeDetailsToLowestFormat(gradeDetails, props);
					for (let a = 0; a < keysArray.length; a++) {
						let callDataObj = props.dataTableMap.get(keysArray[a]);
						let className;
						// only GRADE
						if (callDataObj.group === undefined) {
							className = callDataObj.grade;
							let gradeDetails = {
								allGrades: false,
								gradeLevels: [],
								grades: [{
									grade: callDataObj.grade,
								}],
							}
							let grade_gradeStringArray = gradePickerUtil.convertingGradeDetailsToLowestFormat(gradeDetails, props);
							let allGradePresent = lodashUtil.difference(grade_gradeStringArray, calendar_gradeStringArray)
							if (allGradePresent.length > 0) {
								isAllSelectedGradePresent = false;
								break;
							}
						}
						//GROUPS with GRADE
						else {
							className = callDataObj.grade + callDataObj.group
							if (!calendar_gradeStringArray.includes(className)) {
								isAllSelectedGradePresent = false;
								break;
							}
						}
					}
					if (isAllSelectedGradePresent === true) {
						periodsArrayToDisplay = PreferredPeriodsUtil.getPeriodNameArray(calendar.periodsDetails);
					}
				}
			//}
			// if the calendar grade detail dosent have the selected cell grade. ERROR message
			if (isAllSelectedGradePresent === false) {
				this.state.isScheduleOpen = false
				this.props.handleCloseForDialog()
				toast(i18n.preferredPeriod.periodNotPresentInCalendar);

			}
		}
		this.setState({
			periodsArrayToDisplay: periodsArrayToDisplay
		})
	}

	render() {
		return (
			<MuiGrid container xs={12}>
				<PreferredPeriodComponent
					{...this.state}
					{...this.props}
					onClickOfSave={this.onClickOfSave}
					removeWeeklyAvailabilitySchedule={this.removeWeeklyAvailabilitySchedule}
					renderAvailabilityScheduleRow={this.renderAvailabilityScheduleRow}
				/>
			</MuiGrid>
		)
	}
}

export default PreferredPeriodContainer
